import Card from "../components/Card";

function Search() {
    return <>
    <Card cardOrder={1} />
  </>
}

export default Search;